export default __webpack_public_path__ + "static/ringpours-757937d4c19a35969c5c77a4194e259e.png";